 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTRITA_M_HOPKINSTHE_GHOST_WHO_LIVED_IN_THE_CUPBOARD26244_EPUB2 from '@/components/Text/Rita_M._Hopkins-The_Ghost_Who_Lived_in_the_Cupboard-26244_Epub-2'
 import TEXTRITA_M_HOPKINSTHE_GHOST_WHO_LIVED_IN_THE_CUPBOARD26244_EPUB3 from '@/components/Text/Rita_M._Hopkins-The_Ghost_Who_Lived_in_the_Cupboard-26244_Epub-3'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
		{
 			"path" : "/",
 			"name" : "home",
 			"components" : {
				default: Home
			}
 		},
 		{
 			"path" : "/tcpage1",
 			"name" : "tcpage1"
 			,"components" : {
				 left: TEXTRITA_M_HOPKINSTHE_GHOST_WHO_LIVED_IN_THE_CUPBOARD26244_EPUB2
				 ,
				 right: TEXTRITA_M_HOPKINSTHE_GHOST_WHO_LIVED_IN_THE_CUPBOARD26244_EPUB3
			}
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"components" : {
				default: Last
			}
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js